import CardMultiSectionContainer from "./CardMultiSectionContainer";

export default function EssentialInfoCard({
	Icon,
	title,
	description,
	iconSize,
	cardHeight,
	bgColor,
	lineColor,
	onClick,
	classes=""
}: {
	Icon: any;
	title: string;
	description: string;
	iconSize: string;
	cardWidth?: string | false;
	cardHeight?: string | false;
	bgColor: string;
	lineColor: string;
	onClick?: () => void;
	classes?: string;
}) {
	return (
		<>
			{lineColor && bgColor && (
				<CardMultiSectionContainer
					onClick={onClick}
					classes={classes}
				>
					<div
						className={`
							w-[33px] sm:w-[30px] md:w-[35px] lg:w-[45px] xl:w-[3.5vw] 
							h-[33px] sm:h-[30px] md:h-[35px] lg:h-[45px] xl:h-[3.5vw] mb-2 2xl:mb-[1vw]
							flex justify-center items-center rounded-full 
							first:scale-[0.8] xl:first:scale-[1] 2xl:first:scale-[1.1] 
						`}
						style={{
							backgroundColor: bgColor,
							color: lineColor,
						}}
					>
						<Icon size={iconSize} />
					</div>
					<p className="font-bold text-xs lg:text-sm xl:text-base 2xl:text-[1.2vw]">{title}</p>
					<p 
						className={`
							text-balance text-xs lg:text-sm xl:text-base 2xl:text-[1.1vw] 
							${cardHeight && "h-[70px] 2xl:h-[6vw]"}
						`}
					>
							{description}
					</p>
				</CardMultiSectionContainer>
			)}
		</>
	);
}
